import { PImage } from "../../../../shared/PImage/PImage";
import {
  GraphicTypeEnum,
  OfferUIDetails,
} from "../../../../../services/redux/types/CartLoyaltyV2Types";

import { useAppSelector } from "../../../../../services/hooks/useReduxHooks";
import { mapLoyaltyOfferIconSlug } from "../../../../global/LoyaltyOfferIcon/LoyaltyGraphicIcon";
import Offer from "../../../../../utils/OfferClass/Offer/Offer";
import styles from "./bundleItemImage.module.scss";
import { ItemImageBorder, Lineicon, SparkleIcon, StarIcon } from "./icons";

export const BundleOfferImages = (props: {
  urls?: string[];
  graphics?: OfferUIDetails["graphics"];
  large?: boolean;
  transparentBg?: boolean;
  /** Loyalty `uiConfig.graphics` / icon slugs (`OfferIconSlug`); uses loyalty icon map instead of `Offer.mapOfferIcon`. */
  loyaltyGraphics?: boolean;
  // transformTopLeft?: boolean;
  customScale?: number;
  flipGraphicColors?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}) => {
  const { restaurantInfo } = useAppSelector((state) => state.config);
  const alternatePercentageIcon =
    restaurantInfo?.config?.alternatePercentageIcon;

  const graphics =
    props.graphics ??
    props.urls?.map((url) => ({ type: GraphicTypeEnum.IMAGE, value: url })) ??
    [];

  const styleName = `items_${graphics?.length}`;

  const mapOfferUi = (graphic: { type: GraphicTypeEnum; value: string }) => {
    switch (graphic.type) {
      case GraphicTypeEnum.IMAGE:
        return (
          <PImage
            src={graphic.value}
            alt={""}
            fill
            style={{ objectFit: "cover", objectPosition: "center" }}
            className={styles.img}
          />
        );

      case GraphicTypeEnum.ICON:
        return props.loyaltyGraphics
          ? mapLoyaltyOfferIconSlug(graphic.value, alternatePercentageIcon)
          : Offer.mapOfferIcon(graphic.value, alternatePercentageIcon);
      case GraphicTypeEnum.TEXT:
        return <span>{graphic.value}</span>;
      default:
        return null;
    }
  };

  return (
    <>
      {graphics && graphics.length > 0 ? (
        <div
          className={`${styles.img_container} ${styles[styleName]} ${
            props.large && styles.large
          } ${props.transparentBg && styles.transparent_bg} ${
            props?.flipGraphicColors && styles.flip_colors
          } ${props.fullWidth && styles.full_width} ${
            props.fullHeight && styles.full_height
          }`}
          style={
            props.customScale
              ? { transform: `scale(${props.customScale})` }
              : {}
          }
        >
          {(graphics.length !== 1 || props.large) && (
            <span className={styles.star}>
              <StarIcon />
            </span>
          )}
          {(graphics.length !== 1 || props.large) && (
            <span className={styles.sparkle}>
              <SparkleIcon />
            </span>
          )}
          <div className={styles.items}>
            {graphics.map((graphic, index: number) => (
              <div key={index} className={`${styles.item_image}`}>
                <span className={styles.item_image__bg}>
                  <ItemImageBorder />
                </span>
                <span className={styles.line}>
                  <Lineicon />
                </span>
                {graphics.length === 1 && !props.large && (
                  <span className={styles.line_2}>
                    <Lineicon />
                  </span>
                )}
                {/* <Image
                  src={url}
                  alt={"Bundle"}
                  className={styles.img}
                  fill
                /> */}
                {/* <MapGeneralOfferIcon graphic={graphic} largeIcons /> */}
                <div className={`${styles.graphic}`}>{mapOfferUi(graphic)}</div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
